import React from "react";
import { Tag } from "antd";
import { getScoreGrade } from "../../../common/Grade";

interface SimulationScoreProps {
    score: number;
}

export const SimulationScore: React.FC<SimulationScoreProps> = ({ score }) => {
    const grade = getScoreGrade(score);
    const color = grade?.tag;

    return (
        <Tag color={color} data-testid="simulation-score">
            {score}%
        </Tag>
    );
};
